/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { DataTable, DataTableSortEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import Loader from "../../../components/loader";
import PrimePaginator from "../../../components/prime-paginator";
import DeleteConfirmationDialog from "../../../components/delete-confirmation";
import { PaginatorPageChangeEvent } from "primereact/paginator";
import { ConfirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { checkActionAuthorization, downloadCsvFile, IsFormValid, } from "../../../service/shared.service";
import { IsNullOrEmptyArray, IsStringNullEmptyOrUndefined, } from "../../../utils/null-check";
import { toastOptObj } from "../../../utils/constants";
import { Dialog } from "primereact/dialog";
import { APIResponseEntity } from "../../../interface/api-responce";
import { PaginateRespEntity } from "../../../interface";
import { AxiosResponse } from "axios";
import { APIToGetDepartmentMaster, APIToCreateDepartmentMaster, APIToUpdateDepartmentMaster, APIToDeleteDepartmentMaster, APIToExportDepartmentMaster, } from "../../../service/api-service";
import { RadioButton } from "primereact/radiobutton";
import { DepartmentMasterDetailsEntity, DepartmentMasterFilterRequest, } from "../../../interface/production-master";
import { Dropdown } from "primereact/dropdown";

const Status = [
    { name: "Active", code: true },
    { name: "Inactive", code: false },
];
function Department() {
    const [status] = useState(["Active", "Inactive"]);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [departmentDetails, setDepartmentDetails] = useState<DepartmentMasterDetailsEntity[]>([]);
    const [totalPageCount, setTotalPageCount] = useState<number>(0);
    const [filterReq, setFilterReq] = useState<DepartmentMasterFilterRequest>({
        pageSize: 10,
        pageNumber: 0,
        sortColumn: "createdAt",
        sortOrder: "desc",
        codesearchText: "",
        namesearchText: "",
        status: "",
        APICallCount: 0,
    });
    const [isDeleteRecordId, setIsDeleteRecordId] = useState<string>("");
    const [isDepartmentDialogVisible, setIsDepartmentDialogVisible] = useState<boolean>(false);
    const [isEditMode, setIsEditMode] = useState<boolean>(false);
    const [selectedDepartmentId, setSelectedDepartmentId] = useState<string>("");
    const [departmentCode, setDepartmentCode] = useState<string>("");
    const [departmentName, setDepartmentName] = useState<string>("");
    const [submitted, setSubmitted] = useState<boolean>(false);
    const [departmentIsActive, setDepartmentIsActive] = useState<boolean>(true);
    const [formErrors, setFormErrors] = useState({
        code: "Please enter code",
        name: "Please enter name",
    });
    useEffect(() => {
        const delayDebounceFn = setTimeout(async () => {
            await fetchDepartments();
        }, 300);
        return () => clearTimeout(delayDebounceFn);
    }, [filterReq]);

    const fetchDepartments = async (): Promise<void> => {
        setIsLoading(true);
        const reqObj = {
            pageNumber: filterReq.pageNumber,
            pageSize: filterReq.pageSize,
            sortOrder: filterReq.sortOrder,
            sortColumn: filterReq.sortColumn,
            codesearchText: filterReq.codesearchText,
            namesearchText: filterReq.namesearchText,
            ...(!IsStringNullEmptyOrUndefined(filterReq.status) && {
                status: filterReq.status,
            }),
        };
        const resp: AxiosResponse<APIResponseEntity> = await APIToGetDepartmentMaster(reqObj);
        setIsLoading(false);
        setDepartmentDetails([]);
        setTotalPageCount(0);
        if (resp) {
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const paginateResp: PaginateRespEntity = axiosResp.data;
                    setDepartmentDetails(paginateResp.data);
                    setTotalPageCount(paginateResp.totalCount);
                } else {
                    toast.error(axiosResp.message, { ...toastOptObj, });
                }
            } else {
                toast.error(resp.data.message, { ...toastOptObj, });
            }
        }
    };

    const onPageChange = (
        event: PaginatorPageChangeEvent
    ): void => {

        setFilterReq(prev => ({
            ...prev,
            pageSize: event.rows,
            pageNumber: event.page,
            APICallCount:
                prev.APICallCount + 1,
        }));

    };

    const onTableSort = (
        event: DataTableSortEvent
    ): void => {

        if (event && event.sortField && event.sortOrder) {

            setFilterReq(prev => ({
                ...prev,
                sortColumn: event.sortField as string,
                sortOrder: event.sortOrder === 1 ? "asce" : "desc",
                pageNumber: 0,
                APICallCount: prev.APICallCount + 1,
            }));

        }
    };

    const handleAdd = (): void => {
        setIsEditMode(false);
        setSelectedDepartmentId("");
        setDepartmentCode("");
        setDepartmentName("");
        setSubmitted(false);
        setIsDepartmentDialogVisible(true);
        setDepartmentIsActive(true);
        setFormErrors({
            code: "Please enter code",
            name: "Please enter name",
        });
    };

    const handleEdit = (rowData: DepartmentMasterDetailsEntity): void => {
        if (!rowData || IsStringNullEmptyOrUndefined(rowData.id)) {
            return;
        }

        setSelectedDepartmentId(rowData.id);
        setDepartmentCode(rowData.code || "");
        setDepartmentName(rowData.name || "");
        setDepartmentIsActive(rowData.isActive ?? true);
        setIsEditMode(true);
        setSubmitted(false);
        setIsDepartmentDialogVisible(true);
        setFormErrors({
            code: "",
            name: "",
        });
    };

    const closeDepartmentDialog = (): void => {
        setIsDepartmentDialogVisible(false);
        setIsEditMode(false);
        setSelectedDepartmentId("");
        setDepartmentCode("");
        setDepartmentName("");
        setSubmitted(false);
        setDepartmentIsActive(true);
    };

    const deleteDepartment = async (value: boolean): Promise<void> => {
        if (!value) {
            return;
        }

        setIsLoading(true);

        try {
            const resp: AxiosResponse<APIResponseEntity> =
                await APIToDeleteDepartmentMaster(isDeleteRecordId);

            if (resp) {
                if (resp && resp.data && resp.status === 200) {
                    const axiosResp: APIResponseEntity = resp.data;

                    if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                        toast.success(axiosResp.message, { ...toastOptObj });
                        setIsDeleteRecordId("");

                        setFilterReq(prev => ({
                            ...prev,
                            APICallCount: prev.APICallCount + 1,
                        }));
                    }
                } else {
                    toast.error(resp?.data?.message || "Unable to delete department", { ...toastOptObj });
                }
            }
        } catch (error) {
            toast.error("Unable to delete department", { ...toastOptObj });
        } finally {
            setIsLoading(false);
        }
    };
    const actionIconTemplate = (rowData: DepartmentMasterDetailsEntity) => {
        return (
            <ul className="tableIcon cursor-pointer action-icon-template-w">

                {checkActionAuthorization("update", "Department Master") &&
                    <li
                        data-toggle="tooltip"
                        title="Edit"
                    >
                        <img
                            src="assets/images/edit-icon.svg"
                            alt="Edit"
                            onClick={() => {
                                handleEdit(rowData);
                            }}
                        />
                    </li>
                }

                {checkActionAuthorization("delete", "Department Master") &&
                    <li
                        data-toggle="tooltip"
                        title="Delete"
                        onClick={() => {
                            setIsDeleteRecordId(rowData.id);
                        }}
                    >
                        <DeleteConfirmationDialog
                            isAccepted={deleteDepartment}
                        />
                    </li>
                }

            </ul>
        );
    };

    const resetFilters = (): void => {
        setSelectedStatus("");
        setFilterReq(prev => ({
            ...prev,
            pageSize: 10,
            pageNumber: 0,
            sortColumn: "createdAt",
            sortOrder: "desc",
            codesearchText: "",
            namesearchText: "",
            status: "",
            APICallCount: prev.APICallCount + 1,
        }));

    };

    const statusBodyTemplate = (rowData: DepartmentMasterDetailsEntity) => {
        return (
            <span
                className={`badge badge-${rowData.isActive === true
                    ? "success"
                    : "danger"
                    }`}
            >
                {rowData.isActive ? "Active" : "Inactive"}
            </span>
        );
    };

    const showSingleErrorToast = (message: string): void => {
        toast.dismiss();
        toast.error(message, { ...toastOptObj });
    };

    const handleSaveDepartment = async (): Promise<void> => {
        setSubmitted(true);
        const isValid = IsFormValid(formErrors);

        if (!isValid) {
            return;
        }
        setIsLoading(true);
        let resp: AxiosResponse<APIResponseEntity>;
        if (isEditMode) {
            resp = await APIToUpdateDepartmentMaster(
                selectedDepartmentId,
                {
                    code: departmentCode.trim(),
                    name: departmentName.trim(),
                    isActive: departmentIsActive,
                }
            );
        } else {
            resp = await APIToCreateDepartmentMaster({
                code: departmentCode.trim(),
                name: departmentName.trim(),
            });
        }
        if (resp && resp.data && (resp.status === 200 || resp.status === 201)) {
            const axiosResp: APIResponseEntity = resp.data;
            if (axiosResp && (axiosResp.statusCode === 200 || axiosResp.statusCode === 201)) {
                toast.success(axiosResp.message, { ...toastOptObj, });
                closeDepartmentDialog();
                setFilterReq(prev => ({
                    ...prev,
                    pageNumber: 0,
                    APICallCount:
                        prev.APICallCount + 1,
                }));
                setIsLoading(false);
            } else {
                showSingleErrorToast(axiosResp?.message || "Unable to save department");
                setIsLoading(false);
            }
        }
        setIsLoading(false);

    };

    const fetchDepartmentMasterCsvDetails = async (): Promise<void> => {
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIToExportDepartmentMaster();
        setIsLoading(false);
        if (resp) {
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (
                    axiosResp &&
                    axiosResp.data &&
                    axiosResp.status &&
                    axiosResp.statusCode === 200
                ) {
                    const excelUrl = axiosResp.data.xlsxUrl;
                    if (excelUrl && !IsStringNullEmptyOrUndefined(excelUrl)) {
                        const fileName: string = excelUrl.split("/").pop();
                        if (fileName && !IsStringNullEmptyOrUndefined(fileName)) {
                            await downloadCsvFile(excelUrl, fileName)
                        }
                    }
                };
            }
            else {
                toast.error(resp.data.message, { ...toastOptObj });
            }
        }

    };

    const codeFilterTemplate = () => {
        return (
            <InputText
                value={filterReq.codesearchText}
                placeholder="Search by code"
                onChange={(e) =>
                    setFilterReq(prev => ({
                        ...prev,
                        codesearchText: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }))
                }
            />
        );
    };

    const nameFilterTemplate = () => {
        return (
            <InputText
                value={filterReq.namesearchText}
                placeholder="Search by name"
                onChange={(e) =>
                    setFilterReq(prev => ({
                        ...prev,
                        namesearchText: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }))
                }
            />
        );
    };

    const statusRowFilterTemplate = (options: any) => {
        return (
            <Dropdown
                value={selectedStatus}
                options={status}
                onChange={(e) => {
                    handleChangeStatus(e.value);
                }}
                placeholder="Select status"
                className="p-column-filter"
                style={{ minWidth: "12rem" }}
            />
        );
    };

    const handleChangeStatus = (e: string) => {
        setSelectedStatus(e);

        setFilterReq(prev => ({
            ...prev,
            status:
                e === "Active"
                    ? "true"
                    : e === "Inactive"
                        ? "false"
                        : "",
            pageNumber: 0,
            APICallCount: prev.APICallCount + 1,
        }));
    };

    const handleChange = (fieldName: string, value: string): void => {
        switch (fieldName) {
            case "code":
                setDepartmentCode(value);

                setFormErrors(prev => ({
                    ...prev,
                    code: IsStringNullEmptyOrUndefined(value)
                        ? "Please enter code"
                        : "",
                }));
                break;
            case "name":
                setDepartmentName(value);

                setFormErrors(prev => ({
                    ...prev,
                    name: !/^[A-Za-z ]+$/.test(value.trim())
                        ? "Please enter valid name"
                        : "",
                }));
                break;

            default:
                break;
        }
    };
    return (
        <>
            <Loader isLoading={isLoading} />
            <ConfirmDialog />
            <div className="content-wrapper">
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="card card-rounded">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="row align-items-center">
                                                <div className="col-lg-5 col-md-5 col-12">
                                                    <h4 className="card-title mb-0">
                                                        Departments master
                                                    </h4>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-12">
                                                    <div
                                                        className="  d-flex justify-content-end align-items-center gap-2 flex-wrap "
                                                    >
                                                        {
                                                            checkActionAuthorization("create", "Department Master") && (
                                                                <button
                                                                    type="button"
                                                                    className=" btn btn-primary btn-md font-weight-medium"
                                                                    onClick={handleAdd}
                                                                >
                                                                    Add Department Master
                                                                </button>

                                                            )
                                                        }
                                                        {checkActionAuthorization('upgrade', 'Allow to Export Department Master') &&
                                                            <button
                                                                type="button"
                                                                className="btn btn-block btn-success btn-md font-weight-medium m-0 me-2 pull-right"
                                                                onClick={() => fetchDepartmentMasterCsvDetails()}
                                                            >
                                                                Export Department Master
                                                            </button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className=" d-flex justify-content-end mt-2"                                                >
                                                <span className="resetFilters text-primary cursor-pointer " onClick={resetFilters}> Reset Filters  </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col">
                                            <DataTable
                                                value={departmentDetails}
                                                filterDisplay="row"
                                                scrollable
                                                sortField={filterReq.sortColumn}
                                                sortOrder={filterReq.sortOrder === "asce" ? 1 : -1}
                                                onSort={onTableSort}
                                                emptyMessage={"No departments found"}
                                            >
                                                <Column
                                                    field="code"
                                                    header="CODE"
                                                    sortable
                                                    filter
                                                    showFilterMenu={false}
                                                    filterElement={codeFilterTemplate}
                                                    style={{ minWidth: "250px" }}
                                                />
                                                <Column
                                                    field="name"
                                                    header="NAME"
                                                    sortable
                                                    filter
                                                    showFilterMenu={false}
                                                    filterElement={nameFilterTemplate}
                                                    style={{ minWidth: "300px" }}
                                                />
                                                <Column field="isActive" header="Status"
                                                    showFilterMenu={false} filter filterElement={statusRowFilterTemplate}
                                                    body={statusBodyTemplate}
                                                    style={{ minWidth: "300px" }}
                                                />

                                                <Column
                                                    field="createdAt"
                                                    header="Date Created"
                                                    sortable
                                                    body={(rowData: DepartmentMasterDetailsEntity) =>
                                                        rowData.createdAt
                                                            ? new Date(rowData.createdAt).toLocaleDateString("en-GB")
                                                            : "-"
                                                    }
                                                    style={{ minWidth: "200px" }}
                                                />

                                                {
                                                    (
                                                        checkActionAuthorization("update", "Department Master") || checkActionAuthorization("delete", "Department Master")) && (
                                                        <Column
                                                            header="Action"
                                                            body={actionIconTemplate}
                                                            style={{ minWidth: "220px" }}
                                                        />
                                                    )
                                                }
                                            </DataTable>
                                        </div>
                                    </div>
                                    {
                                        !IsNullOrEmptyArray(departmentDetails) && (
                                            <div className="mt-3">
                                                <PrimePaginator
                                                    onPageChange={onPageChange}
                                                    pageNumber={filterReq.pageNumber}
                                                    pageSize={filterReq.pageSize}
                                                    totalRecords={totalPageCount}
                                                />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                header={
                    isEditMode
                        ? "Edit Department"
                        : "Add Department"
                }
                className="production-master-dialog"
                contentStyle={{ paddingBottom: "10px" }}
                resizable={false}
                draggable={false}
                visible={isDepartmentDialogVisible}
                style={{ width: "450px" }}
                modal
                onHide={closeDepartmentDialog}
                footer={
                    <div className="d-flex justify-content-end gap-2">

                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={closeDepartmentDialog}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSaveDepartment}
                        >
                            {isEditMode ? "Update" : "Save"}
                        </button>

                    </div>
                }
            >
                <div className="row mt-3">
                    <div className="form-group mb-3">
                        <label>
                            CODE <sup className="mandatory">*</sup>
                        </label>

                        <input
                            type="text"
                            name="code"
                            className="form-control form-control-lg"
                            maxLength={25}
                            value={departmentCode}
                            onChange={(e) =>
                                handleChange(e.target.name, e.target.value)
                            }
                        />

                        {submitted && (
                            <small className="text-danger font-weight-500">
                                {formErrors.code}
                            </small>
                        )}
                    </div>
                    <div className="form-group mb-3">
                        <label>
                            NAME <sup className="mandatory">*</sup>
                        </label>

                        <input
                            type="text"
                            name="name"
                            className="form-control form-control-lg"
                            maxLength={25}
                            value={departmentName}
                            onChange={(e) =>
                                handleChange(e.target.name, e.target.value)
                            }
                        />

                        {submitted && (
                            <small className="text-danger font-weight-500">
                                {formErrors.name}
                            </small>
                        )}
                    </div>
                    {isEditMode && (
                        <div className="form-group">
                            <label>STATUS</label>

                            <div className="d-flex mb-2">
                                {Status.map((option: any) => (
                                    <div
                                        key={option.code}
                                        className="d-flex align-items-center mb-2"
                                    >
                                        <RadioButton
                                            inputId={String(option.code)}
                                            name="status"
                                            className="me-2"
                                            value={option.code}
                                            onChange={(e) =>
                                                setDepartmentIsActive(e.value)
                                            }
                                            checked={
                                                departmentIsActive === option.code
                                            }
                                        />

                                        <label className="me-5">
                                            {option.name}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </Dialog>
        </>
    );
}

export default Department;